<template>
    <div class="app-content-wrapper apps-wrapper --filemanager shadow-lg">
        <div :class="{open: isBlock}" class="app-overlay" @click="overlayApp" />
        <div :class="{open: isOpen}" class="app-sidebar">
            <div class="app-sidebar-header white py-5">
                <v-btn class="rounded-lg py-5" tile block color="primary" @click="openUploadDialog">
                    <v-icon left> mdi-file-plus </v-icon> Add / Upload
                </v-btn>
            </div>
            <vue-perfect-scrollbar
                :settings="{suppressScrollX: true, wheelPropagation: false}"
                class="h-100 rtl-ps-none ps scroll"
                style="height: 100%"
            >
                <div class="app-sidebar-body mt-6">
                    <v-list flat>
                        <v-subheader
                            class="text--disabled font-weight-medium text-uppercase"
                        >
                            ADPOINTS STORAGE                            
                        </v-subheader>
                        <v-list-item-group>
                            <v-list-item
                            selectable
                                v-for="(item, i) in items"
                                :key="i"
                                class="px-10"
                                @click="currentBaseFolder=item.folder"                                
                            >
                                <v-list-item-icon class="mr-3">
                                    <v-icon>{{ currentBaseFolderName.toLowerCase()==item.text.toLowerCase() ? 'mdi-folder' : 'mdi-folder-outline' }}</v-icon>                                    
                                </v-list-item-icon>                                
                                <v-list-item-content>
                                    <v-list-item-title
                                        class="font-weight-medium"
                                        v-text="item.text"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                    
                </div>
            </vue-perfect-scrollbar>
        </div>
        <div class="app-content relative">
            <div class="app-header white" style="position: relative">
                <div class="d-flex justify-space-between flex-wrap align-baseline">
                    <div class="d-flex">
                        <v-icon>mdi-folder-outline</v-icon>
                        <v-breadcrumbs class="pl-3" :items="currentFolderBreadcrumbs">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                            <template v-slot:item="{ item }">
                            <v-breadcrumbs-item @click="currentBaseFolder=item.path">
                                <span style="text-decoration: underline;" class="pltclickable">{{item.text}}</span>
                            </v-breadcrumbs-item>
                        </template>
                        </v-breadcrumbs>                        
                    </div>
                    <div class="d-flex">                        
                        <!-- app-icon class -->
                        <!-- <div
                            class="nested-sidebar-toggle d-md-none d-sm-block"
                            @click="appToggle"
                        >
                            <v-icon color="dark"> mdi-menu-open </v-icon>
                        </div> -->
                        <v-select                                                                     
                            v-model="orderby"
                            :items="[{value: null, text: ' '}, {value: 'nameasc', text: 'Name Asc.'}, {value: 'namedesc', text: 'Name Desc.'}]"
                            label="Ordering"                                                                                                                                                                                                
                        />

                        <v-text-field
                            hide-details="auto"
                            v-model="searchterm"
                            class="sm:hidden md:flex ma-0 pa-0 ml-4"
                            label="Search"
                            outlined
                            dense
                            prepend-inner-icon="mdi-magnify"
                            clearable
                        ></v-text-field>
                    </div>
                    <!-- <div>
                        <v-btn icon color="primary">
                            <v-icon>mdi-account-check</v-icon>
                        </v-btn>
                        <v-btn icon color="primary">
                            <v-icon>mdi-trash-can</v-icon>
                        </v-btn>
                        <v-btn icon color="primary">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </div> -->
                </div>
            </div>
            <vue-perfect-scrollbar
                :settings="{suppressScrollX: true, wheelPropagation: false}"
                class="h-100 rtl-ps-none ps scroll"
                style="height: 100%"
            >
                <div class="app-body mt-10 px-8">

                    <div v-if="loading" class="text-center">
                        <v-progress-circular
                        indeterminate
                        color="primary"
                        ></v-progress-circular>
                    </div>
                    
                    <v-row v-if="!loading">
                        <v-col cols="12" class="">
                            <p
                                class="font-weight-medium ma-0 text--disabled text-12"
                            >
                                FOLDERS
                            </p>
                        </v-col>
                    </v-row>
                    <v-container v-if="!loading" class="grid filemanager-content">
                        <v-row>
                            <v-col v-for="(folder, index) in folders" cols="6" :key="index" class="">
                                <base-card>
                                    <v-card-text class="bg-white pltclickable" @click="currentBaseFolder=folder.fullpath">
                                        <div class="d-flex align-center">
                                            <v-icon class="mr-2">
                                                mdi-folder-outline
                                            </v-icon>
                                            <div>
                                                <p
                                                    style="word-break: break-all;"
                                                    class="font-weight-medium ma-0 "
                                                >
                                                    {{folder.name}}
                                                </p>
                                                <!-- <p
                                                    class="text--disabled ma-0 body-2"
                                                >
                                                    &nbsp;
                                                </p> -->
                                            </div>
                                        </div>
                                    </v-card-text>
                                </base-card>
                            </v-col>
                            
                        </v-row>
                    </v-container>
                    <v-row v-if="!loading" class="mb-10">
                        <v-col cols="12" class="">
                            <p
                                class="font-weight-medium ma-0 text--disabled text-12"
                            >
                                FILES
                            </p>
                        </v-col>
                    </v-row>
                    <v-container v-if="!loading" class="">
                        <v-row>
                            <!-- <div class="grid filemanager-content"> -->
                            <v-col v-for="(file, index) in files" :key="index" md="6" lg="4" style="min-height: 168px;" @click="openAssetUrl(file.assetUrl)">
                                <base-card class="pltclickable">
                                    <div class="py-6">
                                        <v-img
                                            width="40"
                                            class=" h-auto ma-auto"
                                            :src="'https://' + file.thumbnailUrl"
                                            @error="errorHandler(file)"                                            
                                        />                                                                                    
                                    </div>
                                    <v-card-text class="bg-white">
                                        <p
                                            class="card-text font-weight-bold ma-0 "
                                        >
                                            {{file.name}}
                                        </p>
                                        <p
                                            class="text--disabled font-weight-medium ma-0 "
                                        >
                                            {{file.size}}
                                        </p>
                                        <!-- <p>
                                            <v-btn @click="openAssets(asset, index)" x-small outlined>   
                                                    <v-icon class="pr-2">mdi-check</v-icon>
                                                    Select
                                            </v-btn>
                                        </p> -->
                                        <!-- <p class="ma-0 body-2">
                                            Last accessed: 3 Hours ago
                                        </p> -->
                                    </v-card-text>     
                                    <v-card-actions class="text-center">
                                        <v-btn v-if="pickerMode" color="primary" @click.stop="selectAssetFile(file)" small style="margin: auto;">   
                                            <v-icon class="pr-2">mdi-check</v-icon>
                                            Select
                                        </v-btn>
                                    </v-card-actions>                               
                                </base-card>
                            </v-col>                           
                        </v-row>
                        <v-row>
                            <div>&nbsp;</div>
                        </v-row>
                        <v-row>
                            <div>&nbsp;</div>
                        </v-row>
                        <v-row>
                            <div>&nbsp;</div>
                        </v-row>
                    </v-container>
                </div>
            </vue-perfect-scrollbar>
        </div>
        <v-dialog
            v-model="uploadFileDialog"            
            max-width="600px"
        >
            <v-card>
                <v-card-title>
                    <span class="text-h5">Upload A file</span>
                </v-card-title>
                <v-card-text>
                    <v-file-input 
                        type="file"
                        v-model="uploadFilename"
                        enctype="multipart/form-data"
                        name="assetfile"
                        show-size 
                        outlined 
                        @change="(file) => { uploadFile(file, index) }"
                        label="Click Here to upload a file"
                        truncate-length="150"
                        accept=".mp4,.mov,.mkv,.png,.gif,.jpeg,.jpg"
                        :disabled="uploadProgress != null && uploadProgress < 100"
                    >
                    </v-file-input>
                    <p class="mt-0 mb-0 pt-0 pb-0" style="color: green" v-if="uploadProgress != null && uploadProgress < 100" >Uploading {{uploadProgress}}%</p>
                    <v-progress-linear
                        v-if="uploadProgress != null && uploadProgress < 100" 
                        v-model="uploadProgress"
                        color="green"
                        :active="true"   
                        stream                                                                     
                    />
                    <p class="mt-0 mb-0 pt-0 pb-0" style="color: green" v-if="uploadProgress == 100">
                        <v-progress-circular
                            :size="16"
                            :width="3"
                            color="green"
                            indeterminate
                            style="margin-top: -3px;"
                        ></v-progress-circular>
                        Analyzing Asset... Please wait. (Estimated Time Left: {{analysisEstSecondsLeft}} seconds)
                    </p>
                    <v-progress-linear v-if="uploadProgress == 100"
                        value="0"
                        buffer-value="0"
                        color="green"                                                                                                                                               
                        stream                                                     
                    />
                </v-card-text>
            </v-card>
            <v-card>
                <v-card-title> 
                    <span class="text-h5">Or create a folder</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="newFolderName"
                        outlined
                        clearable
                        label="Folder Name"
                        type="text"
                        class="resetappendouter"
                    >
                        <template v-slot:append-outer>
                             <v-btn v-bind="attrs" v-on="on" @click="createFolder" :loading="awaitingServerAction" large class="primary">
                                <v-icon left>
                                mdi-plus
                                </v-icon>
                                Create
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            bottom
            tile
            :color="snackbarColor + ' -accent-2'"            
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>
<script>
import {api} from "src/api/index";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { debounce } from "@/core/ui-utils.js";
export default {
    name: 'Filemanager',
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Filemanager'
    },
    components: {
        VuePerfectScrollbar
    },
    props: {
        pickerMode: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        orderby: null,
        searchterm: null,        
        awaitingServerAction: false,
        newFolderName: null,
        uploadFileDialog: false,
        uploadFilename: null,
        uploadProgress: null,
        analysisEstSecondsLeft: null,
        isOpen: false,
        isBlock: false,
        fallbackFileThumbIcon: require('@/assets/images/webpack.png'),
        currentBaseFolder: '_shared',
        currentBaseFolderName: "Shared",
        campaignFoldersReference: [],
        // item: 1,
        // itemsTwo: 0,
        items: [
            {text: 'Shared', icon: 'mdi-folder-outline', folder: '_shared'},
            {text: 'Campaigns', icon: 'mdi-folder-outline', folder: '/'},
            // {text: 'Design Resources', icon: 'mdi-devices'},
            // {text: 'Recents', icon: 'mdi-clock-outline'},
            // {text: 'Important', icon: 'mdi-star-half-full'},
            // {text: 'Delete Files', icon: 'mdi-trash-can'}
        ],
        // itemsTwo: [
        //     {text: 'Assets', icon: 'mdi-folder-outline'},
        //     // {text: 'Project Folders', icon: 'mdi-devices'},
        //     // {text: 'Recents', icon: 'mdi-clock-outline'},
        //     // {text: 'Important', icon: 'mdi-star-half-full'},
        //     // {text: 'Delete Files', icon: 'mdi-trash-can'}
        // ],
        contents: [],

        loading: true,            
        snackbar: false,
        snackbarColor: 'green',
        snackbarMessage: '',
    }),
    watch: {
        async currentBaseFolder() {
            await this.debouncedFetch();
        },
        async searchterm() {
            await this.debouncedFetch();
        },
        async orderby() {
            await this.debouncedFetch();
        },
    },
    methods: {
        selectAssetFile: function(selectedFile) {
        selectedFile.assetUrl = 'https://' + selectedFile.assetUrl;
        selectedFile.thumbnailUrl = 'https://' + selectedFile.thumbnailUrl;
        selectedFile.uploadResult = {
            success: true,
            message: 'Selected from asset library'
        };
            this.$emit('select',  selectedFile)               
        },
        createFolder: async function() {
            let createRslt = await api.assets.createFolder(this.currentBaseFolder, this.newFolderName);
            this.newFolderName = null;
            this.uploadFileDialog = false;
            await this.fetchData();
        },
        fetchData: async function() {
            if(this.currentBaseFolder.startsWith('_shared')) {
                this.currentBaseFolderName = 'Shared'
            }
            else {
                this.currentBaseFolderName = 'Campaigns'
            }            
            let rslt = await api.assets.getAssetsFolderContents(this.currentBaseFolder, this.orderby, this.searchterm);
            //this.contents.splice(0, this.contents.splice.length);
            //this.contents.push(...rslt.data); 
            this.contents = [];
            this.contents.push(...rslt.data);
        },
        appToggle: function() {
            this.isOpen = !this.isOpen
            this.isBlock = !this.isBlock
        },
        overlayApp: function() {
            this.isOpen = !this.isOpen
            this.isBlock = !this.isBlock
        },
        errorHandler(file) {
            file.thumbnailUrl = this.fallbackFileThumbIcon;
            this.$forceUpdate();
        },
        openAssetUrl(assetUrl) {
            window.open('https://' + assetUrl);
        },
        async uploadFile(file, index) {
            this.uploadProgress=null;
            let propPrefix = '';            
            let formData = new FormData();
            formData.append("file", file);             
            this.analysisEstSecondsLeft = Math.round((file.size / (1024 * 1014)) / 8) + 15;
            this.countDownTimer();
            try {
                const rsp = await api.assets.uploadAsset(
                    formData, this.currentBaseFolder, 
                    (event) => {
                        this.uploadProgress = Math.round((100 * event.loaded) / event.total);
                    }
                );                 
                if(rsp.data.success) {                                                            
                    this.uploadProgress=null;
                    this.uploadFileDialog=false;
                    this.showSuccessSnackbar("File uploaded successfully!");
                    this.analysisEstSecondsLeft=null;
                }                  
            } catch (error) {                
                this.uploadProgress=null;
                this.analysisEstSecondsLeft=null;
                this.showFailSnackbar("Error Uploading File:" + error.response.data.message);                
            }            
            finally {
                let rslt = await api.assets.getAssetsFolderContents(this.currentBaseFolder, this.orderby);                
                this.contents = [];
                this.contents.push(...rslt.data);
            }        
        },        
        openUploadDialog() {
            this.uploadFilename=null;
            this.uploadFileDialog=true;            
        },
        countDownTimer() {                       
                if (this.analysisEstSecondsLeft > 0) {                    
                    setTimeout(() => {
                        this.analysisEstSecondsLeft -= 1
                        this.countDownTimer();
                    }, 1000)
                }
        },
        showSuccessSnackbar(message) {
            this.snackbarColor = "green";
            this.snackbarMessage = message;
            this.snackbar = true;
        },
        showFailSnackbar(message) {
            this.snackbarColor = "red";
            this.snackbarMessage = message;
            this.snackbar = true;
        },
        showSnackbar(message, color="orange") {
            this.snackbarColor = color;
            this.snackbarMessage = message;
            this.snackbar = true;
        },
    },
    computed: {
        currentFolderBreadcrumbs() {
            let rslt = [];
            let pathItems = [];
            if(this.currentBaseFolderName){                
                if (this.currentBaseFolderName=="Shared") {
                    rslt.push({
                        text: this.currentBaseFolderName,
                        path: "_shared"
                    });
                    pathItems.push("_shared");
                }                
                else {
                    rslt.push({
                        text: this.currentBaseFolderName,
                        path: ""
                    });
                    pathItems.push("");
                }
            }            
            let items = this.currentBaseFolder.split('/').filter(i => i != "" && i != "_shared");            
            rslt.push(...(items.map( (i, index)=> {
                let cmpnName = this.campaignFoldersReference.find(c=>c.campaignid == i);
                return {
                    text: cmpnName?.name || i,
                    path: [...pathItems, ...items.slice(0,index)].join('/')
                };
            })));
            return rslt;
        },
        folders() {
            return this.contents.filter(i=>i.type=="folder")
        },
        files() {
            return this.contents.filter(i=>i.type=="file")
        },
    },
    async mounted() {
        try {
            this.loading = true;
            let rslt = await api.assets.getAssetsFolderContents(this.currentBaseFolder);
            let campaigns = await api.assets.getAssetsFolderContents("");
            // this.contents.splice(0, this.contents.splice.length);
            // this.contents.push(...rslt.data);
            this.campaignFoldersReference.push(...campaigns.data.map(c=> ({name: c.name, campaignid: c.fullpath.replace("/", "")})));
            this.contents = [];
            this.contents.push(...rslt.data);     
        } catch (error) {
            
        } finally {
            this.loading = false;
        }
    },
    async created() {
        this.debouncedFetch = debounce(async (newValue, oldValue)=>{
            try {
                this.loading = true;
                //console.log("value changed: ", newValue, oldValue);
               // call fetch API to get results
               return await this.fetchData();
            } catch (error) {
                
            } finally {
                this.loading = false;
            }
     }, 500);
    }
}
</script>
<style lang="scss">

.pltclickable:hover {
    cursor: pointer;
    outline: 1px lightgray solid;
}

.app-content-wrapper {
    position: relative;
    display: flex;
    overflow: hidden;
    height: calc(100vh - 200px);

    .app-overlay {
        position: absolute;
        content: '';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.4);
        display: none;
        z-index: 2;
        transition: all 0.3s ease-in;
        @media only screen and (max-width: 959px) {
            &.open {
                display: block;
                transition: all 0.3s ease-in;
            }
        }
    }
    .app-sidebar {
        width: 280px;
        position: relative;
        transition: all 0.3s ease-in;
        @media only screen and (max-width: 959px) {
            position: absolute;
            left: -340px;
            z-index: 5;
            height: calc(100vh - 120px);
            transition: all 0.3s ease-in;
            &.open {
                left: 0;
            }
        }
        .app-sidebar-header {
            padding: 0.75rem 1.25rem;
            margin-bottom: 0;
            // border-bottom: 1px solid rgba(0, 0, 0, 0.125);
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 1;
        }
        .app-sidebar-body {
            // overflow-y: scroll;
            // height: 100%;
            padding-top: 3.375rem;
            width: 280px;
        }
    }

    .app-content {
        width: calc(100% - 280px);
        @media only screen and (max-width: 959px) {
            width: 100%;
        }
        // margin-left: 30px;
        .app-header {
            padding: 0.75rem 1.25rem;
            margin-bottom: 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.125);
            position: absolute;
            top: 0;
            width: 100%;
            z-index: 1;
        }
        .app-body {
            flex: 1 1 auto;
            padding-top: 3.375rem;
            // overflow-y: scroll;
            height: calc(100% - 130px);
        }
        .app-footer {
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 130px;
        }
    }
}
.app-icon {
    display: none;
    @media only screen and (max-width: 959px) {
        display: block;
    }
}
.eg-filemanager {
    background-color: #fff;
}
.filemanager-content {
    grid-template-columns: repeat(auto-fill, minmax(14rem, 1fr));
}

.apps-wrapper {
    &.--filemanager {
        .nested-sidebar-toggle {
            @media (min-width: 959px) {
                display: none;
            }
        }
    }
}

.resetappendouter .v-input__append-outer {
    margin-top: 6px;
}
</style>
